import { ResponsiveSection } from '@stitch-fix/mode-react';
import { Layout } from '../../components/Layout';
import { OneTrustContent } from '../../components/OneTrustContent/OneTrustContent';
import { SEOData } from '../../components/SEOData';

const PrivacyPage = () => {
  return (
    <Layout viewEventTrackingName="corporate">
      <SEOData
        title="Privacy Policy | Stitch Fix"
        canonicalUrl="https://www.stitchfix.com/privacy"
      />
      <ResponsiveSection mt="0" width={{ sm: 'full-bleed' }} gutter="none">
        <OneTrustContent documentID="2c796dd3-4be2-426c-ab30-fcf1e86eb99a" />
      </ResponsiveSection>
    </Layout>
  );
};

export default PrivacyPage;
